<template>
  <b-modal
    :id="id"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span style="position: relative; top: -2px"
        ><b-icon icon="arrow-down-square"></b-icon
        ></span>
        <span>Recupera da Syncro</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>
    <div class="mx-1">
      <b-overlay center :show="isLoading" rounded="sm">
        <div v-if="!isLoading">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="handleSubmit(saveRecuperaDaSyncro)">
              <b-row>
                <div class="mt-3 form-group col-md-12">
                  <base-input
                    vid="policy_number"
                    name="policy_number"
                    label="Numero Polizza"
                    v-model="form.policy_number"
                    placeholder="Inserisci il numero di polizza"
                    :rules="{ required: true }"
                  />
                </div>
              </b-row>
              <b-row>
                <b-col align="right">
                  <b-button
                    @click="handleSubmit(saveRecuperaDaSyncro)"
                    type="submit"
                    :disabled="invalid"
                    variant="lisaweb"
                    size="sm"
                    class="mt-2 float-right"
                  >
                    Recupera
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
        <template #overlay>
          <div class="text-center mt-6">
            <base-icon name="loading" width="35" height="35" />
            <p id="cancel-label">Operazione in corso...</p>
          </div>
        </template>
      </b-overlay>
    </div>
    <!-- <div class="tableFixHead">ASD: {{ id }}</div> -->
  </b-modal>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import FormMixin from "@/mixins/FormMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
export default {
  mixins: [FormMixin],
  name: "recuperaDaSyncro",
  data() {
    return {
      repository: "zurich",
      resource: "zurich",
      isLoading: false,
      formLoaded: false,
      form: {
        policy_number: null,
      },
    };
  },
  components: {
    BaseIcon,
    BaseInput,
  },
  props: {
    id: {
      type: String,
      default: "recuperaDaSyncroModal",
    },
    type: {
      type: String,
      default() {
        return "";
      },
    },
  },
  methods: {
    saveRecuperaDaSyncro() {
      this.isLoading = true;
      const payload = {
        policy_number: this.form.policy_number,
      };
      const Repo = RepositoryFactory.get(this.rep);
      if (this.type !== "insurance_ancillary" && this.type !== "deferred") {
        this.$showSnackbar({
          preset: "error",
          text: `Siamo spiacenti, c'è stato un errore. Si prega di riprovare più tardi.`,
        });
        this.isLoading = false;
        return;
      }
      // Repo.create_ancillary(payload)
      (this.type === "insurance_ancillary"
          ? Repo.create_ancillary(payload)
          : Repo.create_deferred(payload)
      )
        .then((success) => {
          this.$emit("fetch", this.form.policy_number);
          this.$bvModal.hide(`${this.id}`);
          this.form.policy_number = null;
          let successMsg =
            success.data && success.data.message
              ? success.data.message
              : success;
          successMsg = successMsg ? successMsg : "";
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: ${
              successMsg ? successMsg : "Recupera da Syncro"
            }`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.isLoading = false;
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId !== this.id) return;
      this.form.policy_number = null;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
  beforeMount() {},
};
</script>
<style scoped>
/* Just common table stuff. Really. */
table {
  border-collapse: collapse;
  width: 100%;
}

:deep(.modal-dialog .btn-group) {
  flex: 1;
}
:deep(.modal-dialog .btn-group > span) {
  display: block;
  width: 100%;
}
:deep(.modal-dialog .btn-group > span input[type="text"]) {
  border: 1px solid var(--gray-300);
  border-radius: 0.25rem;
}
:deep(.modal-dialog .btn-group + .btn) {
  height: 32px;
}
</style>